module.exports = __webpack_public_path__ + "static/media/sample-tube.97f7b394.svg";